// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__EzNX9","inputWrap":"CustomTip_inputWrap__2VrVx"};